export const actionStatuses = Object.freeze({
    IDLE : 'idle',
    PENDING: 'pending',
    FULFILLED: 'fulfilled',
    REJECTED: 'rejected',
})
